import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useGeolocationStore } from "@/common/store/geolocationStore";
import { useUserStore } from "@/common/store";
import { isPageAllowed } from "@/common/utils/geoRules";
import { useScrollStore } from "@/common/store/scrollStore";

export const useCensor = () => {
  const { pathname } = useLocation();

  const location = useGeolocationStore((state) => state.location);
  const currentUser = useUserStore((state) => state.currentUser);
  const appElement = useScrollStore((state) => state.scrollElement);

  useEffect(() => {
    if (isPageAllowed(pathname, location)) {
      appElement?.classList.remove("censored");
      return;
    }

    appElement?.classList.add("censored");

    if (currentUser && currentUser.verified) {
      appElement?.classList.remove("censored");
    }
  }, [appElement, pathname, currentUser, location]);
};
